import { render, staticRenderFns } from "./information-statistics.vue?vue&type=template&id=ae28addc&scoped=true"
import script from "./information-statistics.vue?vue&type=script&lang=js"
export * from "./information-statistics.vue?vue&type=script&lang=js"
import style0 from "./information-statistics.vue?vue&type=style&index=0&id=ae28addc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae28addc",
  null
  
)

export default component.exports